<template>
  <ul>
    <li v-for="(group, idx) in attributes" :key="idx" :class="{ 'mb-1': idx + 1 !== attributes.length }">
      <sidebar-form :attributes="group.elements" :label="group.label" :values="values" />
    </li>
  </ul>
</template>

<script>
import SidebarForm from '@/components/sidebar/SidebarForm';

export default {
  name: 'SidebarForms',
  components: { SidebarForm },
  props: {
    attributes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
